import Switch from "@mui/material/Switch";
import Swal from 'sweetalert2'
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { v4 as uuidv4 } from 'uuid';
import Dropdown from "react-bootstrap/Dropdown";
import Button from "@mui/material/Button";
import dayjs, { Dayjs } from "dayjs";
import NavBar from "../../structure/NavBar";
import Form from "react-bootstrap/Form";
import SearchIcon from "@mui/icons-material/Search";
import InputGroup from "react-bootstrap/InputGroup";
import AddIcon from "@mui/icons-material/Add";
import { NavBarTop } from "../../structure/NavBarTop";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useCallback, useEffect, useReducer, useState } from "react";
import NoDataImg from "../../../assets/img/no-data.gif";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";
import DesktopMacIcon from "@mui/icons-material/DesktopMac";
import Image from "../../custom/Image";
import {
  updateTopHeader,
  uplodateLoading,
} from "../../../redux/features/common/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import urls from "../../constants/apiurl";
import ApiCaller from "../../constants/ApiCaller";
import { showDangerToast, showToast } from "../../constants/toaster";
import { AddLanguage } from "./AddLanguage";
import Utils from "../../constants/Utils";
import InsufficientPermission from "../../custom/InSufficientPermission";
const label = { inputProps: { "aria-label": "Size switch demo" } };
export const LanguageList = (props) => {
  const { formatDate } = Utils();
  const [callAPi, setCallAPi] = useState('')
  const LOADING_ENABLE = useSelector(state => state?.loading)
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [statusDropdownText, setStatusDropdownText] = useState("Select Status");
  const [showAddTag, setShowAddTag] = useState(false);
  const [enableSequenceEdit, setEnableSequenceEdit] = useState(false);
  const [value, setValue] = useState(dayjs());
  const dispatch = useDispatch();
  const [datalist, setDatalist] = useState([]);
  const [defaultWidgetOption, setDefaultWidgetOption] = useState(null);
  const [widgetKeyValueData, setWidgetKeyValueData] = useState([]);
  const [showAddFilter, setShowAddFilter] = useState(false);
  const [sort_type, setSortType] = useState("createdAt");
  const [sort_order, setSortOrder] = useState(false);
  const userData = useSelector((state) => state?.userData);
  const [page, setPage] = useState(1);

  const [edit, setEdit] = useState(false);
  const [active, setActive] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [view, setView] = useState(false);
  const [openActionId, setOpenActionId] = useState(null);
  const [actionMenuPos, setActionMenuPos] = useState(null);
  const handleChange = (event, value) => {
    setPage(value);
    setPagerecord({
      totalItems: pagerecord?.totalItems,
      totalPages: pagerecord?.totalPages,
      pageNumber: value,
      pageSize: 10,
    });
    setCallAPi(uuidv4())
  };
  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1,
  });
  const [languageFormData, setLanguageFormData] = useState({
    id: "",
    name: "",
    code: ""
  });

  const handleFilterClick = useCallback(() => {
    setPage(1);
    setPagerecord({
      ...pagerecord,
      pageNumber: 1
    })
    setCallAPi(uuidv4())
  }, [searchText, startDate, endDate, statusDropdownText]);

  const handleResetFilter = () => {
    setStartDate(null);
    setEndDate(null);
    setStatusDropdownText("Select Status");
    setSearchText("");
    setPage(1);
    setPagerecord({
      ...pagerecord,
      pageNumber: 1
    })
    setCallAPi(uuidv4())
  };

  const handleOnSubmitLanguageModel = async () => {
    try {
      dispatch(uplodateLoading(true));
      let path = urls.addLanguage;
      let res = await ApiCaller.post(languageFormData, path, userData?.access_token);
      const response = await res.response.json();
      if (response.status == 200) {
        dispatch(uplodateLoading(false));
        showToast(response?.message);
        handleHideForm()
        getLanguageList();
      } else {
        dispatch(uplodateLoading(false));
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(uplodateLoading(false));
      console.error(error);
      showDangerToast(error.message);
    }
  };

  const handleDeleteLanguage = (item) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!'
    }).then(async result => {
      if (result.isConfirmed) {
        deleteApiCall(item?.id)
      }
    })
  }


  const deleteApiCall = async id => {
    try {
      dispatch(uplodateLoading(true))
      let path = urls.deleteLanguage + '/' + id
      let res = await ApiCaller.delete({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(uplodateLoading(false))
        Swal.fire('Deleted!', response?.message, 'success')
        getLanguageList()
      } else {
        dispatch(uplodateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(uplodateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const getWidgetKeyValuePair = async (roleId) => {
    try {
      dispatch(uplodateLoading(true));
      let path = urls.widgetKeyValuePair;
      let res = await ApiCaller.get({}, path, userData?.access_token);
      const response = await res.response.json();
      if (response.status == 200) {
        dispatch(uplodateLoading(false));
        let tempWidgetKeyValueList = [{ value: "", label: "Select Widget" }];
        response?.data?.map((data, i) => {
          tempWidgetKeyValueList.push({ value: data?.value, label: data?.key });
          if (data?.key === roleId) {
            setDefaultWidgetOption({ value: data?.value, label: data?.key });
          }
        });
        setWidgetKeyValueData(tempWidgetKeyValueList);
      } else {
        dispatch(uplodateLoading(false));
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(uplodateLoading(false));
      console.error(error);
      showDangerToast(error.message);
    }
  };

  const handleChangeSequence = (event) => {
    switch (event.detail) {
      case 1: {
        setEnableSequenceEdit(false);
        break;
      }
      case 2: {
        setEnableSequenceEdit(true);
        break;
      }
      case 3: {
        setEnableSequenceEdit(false);
        break;
      }
      default: {
        setEnableSequenceEdit(false);
        break;
      }
    }
  };

  const handleHideForm = () => {
    setShowAddTag(false)
    setLanguageFormData({ name: "", id: "", code: "" })
  }

  const handleEditLanguage = (item) => {
    setLanguageFormData(item);
    setShowAddTag(true);
  };

  useEffect(() => {
    dispatch(updateTopHeader("Language Manager"));
  }, []);

  useEffect(() => {
    if (openActionId == null) return;
    const closeMenu = () => {
      setOpenActionId(null);
      setActionMenuPos(null);
    };
    document.addEventListener("click", closeMenu);
    window.addEventListener("scroll", closeMenu, true);
    return () => {
      document.removeEventListener("click", closeMenu);
      window.removeEventListener("scroll", closeMenu, true);
    };
  }, [openActionId]);

  useEffect(() => {
    if(viewPermission){
      getLanguageList();
    }
  }, [callAPi]);

  const handleStatusChange = async (event, id) => {
    try {
      dispatch(uplodateLoading(true));
      let path = urls.changeLanguageStatus + "/" + id;
      let res = await ApiCaller.put({}, path, userData?.access_token);
      const response = await res.response.json();
      if (response.status == 200) {
        dispatch(uplodateLoading(false));
        showToast(response?.message);
        getLanguageList();
      } else {
        dispatch(uplodateLoading(false));
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(uplodateLoading(false));
      console.error(error);
      showDangerToast(error.message);
    }
  };

  const userPermisiions = useSelector(state => state?.permission)
  let currentModulePermission;
  let viewPermission = true;
  let editPermission = true;
  let deletePermissionVal = true;
  let activePermission = true;

  if(userPermisiions?.modules.length>0){
    currentModulePermission = userPermisiions.modules.find((element)=>{
      if(element.moduleId==='26'){
         return element
      }
    })?.permissions
     viewPermission = currentModulePermission.find((element)=>{
      if(element.name==='VIEW'){
        return element
      }
    }).isEnable
     editPermission = currentModulePermission.find((element)=>{
      if(element.name==='EDIT'){
        return element
      }
    }).isEnable
    deletePermissionVal = currentModulePermission.find((element)=>{
      if(element.name==='DELETE'){
        return element
      }
    }).isEnable
    activePermission = currentModulePermission.find((element)=>{
      if(element.name==='ACTIVE'){
        return element
      }
    }).isEnable
   }


  const getLanguageList = async () => {
    let startDateObject;
    let endDateObject;
    if (startDate?.toDate()) {
      let newDate = new Date(startDate?.toDate());
      newDate.setDate(newDate.getDate() + 1);
      startDateObject = newDate;
    }
    if (endDate?.toDate()) {
      let newDate = new Date(endDate?.toDate());
      newDate.setDate(newDate.getDate() + 1);
      endDateObject = newDate;
    }
    try {
      dispatch(uplodateLoading(true));
      let postJson = {
        searchText: searchText?.trim(),
        pageNumber: pagerecord?.pageNumber - 1 || 0,
        pageSize: pagerecord.pageSize || 10,
        shortingField: sort_type,
        active:
          statusDropdownText === "Active"
            ? true
            : statusDropdownText === "In Active"
              ? false
              : null,
        asc: sort_order,
        startDate:
          startDateObject !== null
            ? startDateObject
            : '',
        endDate:
          endDateObject !== null
            ? endDateObject
            : '',
      };
      let path = urls.languageList;
      let res = await ApiCaller.post(postJson, path, userData?.access_token);
      const response = await res.response.json();
      if (response.status == 200) {
        dispatch(uplodateLoading(false));
        setDatalist(response?.data?.response?.items);

        response?.data?.permissionList.forEach((module, moduleIndex) => {
          if (module.permissionName === "EDIT") {
            setEdit(module.isEnable);
          } else if (module.permissionName === "ACTIVE") {
            setActive(module.isEnable);
          } else if (module.permissionName === "DELETE") {
            setDeletePermission(module.isEnable);
          } else if (module.permissionName === "VIEW") {
            setView(module.isEnable);
          }
        });
        setPagerecord({
          totalItems: response?.data?.response?.totalItems,
          totalPages: response?.data?.response?.totalPages,
          pageNumber: pagerecord?.pageNumber,
          pageSize: 10,
        });
      } else {
        dispatch(uplodateLoading(false));
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(uplodateLoading(false));
      console.error(error);
      showDangerToast(error.message);
    }
  };

  return (
    <>
      <>
        <NavBar />
        <div className="main-content">
          <NavBarTop />
          <div className="header">
            <div className="logo">
              <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8"></div>
            </div>
          </div>
        {
          viewPermission ? (
            <>
                      <div className="container-fluid mt--7">
            <div className="row">
              <div className="col text-left">
                <div className="card shadow">
                  <div className="card-header border-0">
                    <div className="row align-items-center text-left">
                      <div className="col">
                        <h3 className="mb-0">Language Manager</h3>
                      </div>
                      <div className="col text-right">
                        {userData.admin ? (
                          <a
                            className="btn btn-sm btn-primary text-white"
                            onClick={() => setShowAddTag(true)}
                          >
                            <AddIcon />
                            Add Language
                          </a>
                        ) : edit ? (
                          <a
                            className="btn btn-sm btn-primary text-white"
                            onClick={() => setShowAddTag(true)}
                          >
                            <AddIcon />
                            Add Language
                          </a>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card-header border-0">
                    <div className="row align-items-center text-left">
                      <div className="col-md-3">
                        <InputGroup
                          className="mb-2"
                          style={{ borderRadius: "10px" }}
                        >
                          <Form.Control
                            placeholder="Search by Name"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            aria-label="Amount (to the nearest dollar)"
                          />
                        </InputGroup>
                      </div>
                      <div className="col-md-2 mb-2 " style={{ marginRight: "30px" }}>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="success"
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid #cad1d7",
                              boxShadow: "none",
                              transform: "none",
                            }}
                            id="dropdown-basic"
                          >
                            {statusDropdownText}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() =>
                                setStatusDropdownText("Select Status")
                              }
                            >
                              Select Status
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => setStatusDropdownText("Active")}
                            >
                              Active
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => setStatusDropdownText("In Active")}
                            >
                              In Active
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <div
                        className="col-md-6 mb-3"
                        style={{ marginLeft: "10px" }}
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer
                            components={["DatePicker", "DatePicker"]}
                          >
                            <DatePicker
                              disableFuture
                              className="custom-date"
                              label="From Date"
                              value={startDate}
                              onChange={(newValue) => setStartDate(newValue)}
                              maxDate={endDate}
                            />
                            <DatePicker
                              disableFuture
                              label="To Date"
                              value={endDate}
                              onChange={(newValue) => setEndDate(newValue)}
                              minDate={startDate}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </div>
                      <div className="col-md-4 mb-2">
                        <Button
                          variant="contained"
                          className="custom-filter-btn"
                          onClick={handleFilterClick}
                        >
                          Filter
                        </Button>
                        <Button
                          variant="contained"
                          className="ml-2 custom-filter-btn"
                          onClick={handleResetFilter}
                        >
                          Reset
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    {datalist && datalist?.length > 0 ? (
                      <>
                        <table className="table align-items-center table-flush">
                          <thead className="thead-light">
                            <tr>
                              <th scope="col">S/No.</th>
                              <th scope="col">Name</th>
                              <th scope="col">Code</th>
                              <th scope="col">UUID</th>
                              <th scope="col">Date of Creation</th>
                              <th scope="col">Status</th>
                              {(editPermission || deletePermissionVal) && <th scope="col">Action</th>}
                            </tr>
                          </thead>
                          <tbody>
                            {datalist &&
                              datalist?.map((data, i) => {
                                const startIndex = (pagerecord.pageNumber - 1) * pagerecord.pageSize;
                                const rowId = data?.id || i;
                                const isActionOpen = openActionId === rowId;
                                return (
                                  <tr key={rowId}>
                                      <td>{startIndex + i + 1}</td>
                                      <td>{data?.name}</td>
                                      <td>{data?.code}</td>
                                      <td style={{ maxWidth: 220, wordBreak: "break-all" }}>
                                        {data?.id || "-"}
                                      </td>
                                      <td>
                                        {formatDate(data?.createdAt)}
                                      </td>
                                      <td>
                                        {userData.admin ? (
                                          <Switch
                                            {...label}
                                            checked={data?.active}
                                            onChange={(e) =>
                                              handleStatusChange(e, data?.id)
                                            }
                                            size="small"
                                          />
                                        ) : viewPermission ? (
                                          <Switch
                                            {...label}
                                            checked={data?.active}
                                            disabled={!activePermission}
                                            onChange={(e) =>
                                              handleStatusChange(e, data?.id)
                                            }
                                            size="small"
                                          />
                                        ) : (
                                          <></>
                                        )}
                                      </td>
                                    {
                                      (editPermission || deletePermissionVal) &&
                                      <td className="text-right">
                                        <div
                                          className={`dropdown${isActionOpen ? " show" : ""}`}
                                          style={{ position: "relative", display: "inline-block" }}
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-icon-only text-light table-action-toggle"
                                            aria-expanded={isActionOpen}
                                            onClick={(e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              if (isActionOpen) {
                                                setOpenActionId(null);
                                                setActionMenuPos(null);
                                                return;
                                              }
                                              const rect = e.currentTarget.getBoundingClientRect();
                                              setActionMenuPos({
                                                top: rect.bottom + 4,
                                                right: window.innerWidth - rect.right,
                                              });
                                              setOpenActionId(rowId);
                                            }}
                                          >
                                            <i className="fas fa-ellipsis-v" />
                                          </button>
                                          {isActionOpen && actionMenuPos && (
                                            <div
                                              className="dropdown-menu dropdown-menu-right dropdown-menu-arrow show"
                                              style={{
                                                display: "block",
                                                position: "fixed",
                                                top: actionMenuPos.top,
                                                right: actionMenuPos.right,
                                                left: "auto",
                                                zIndex: 2000,
                                              }}
                                              onClick={(e) => e.stopPropagation()}
                                            >
                                              {(userData.admin || editPermission) && (
                                                <a
                                                  className="dropdown-item cursor"
                                                  onClick={() => {
                                                    setOpenActionId(null);
                                                    setActionMenuPos(null);
                                                    handleEditLanguage(data);
                                                  }}
                                                >
                                                  Edit
                                                </a>
                                              )}
                                              {(userData.admin || deletePermissionVal) && (
                                                <a
                                                  className="dropdown-item cursor"
                                                  onClick={() => {
                                                    setOpenActionId(null);
                                                    setActionMenuPos(null);
                                                    handleDeleteLanguage(data);
                                                  }}
                                                >
                                                  Delete
                                                </a>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                    }
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </>
                    ) : (
                      <>
                        <div className="text-center">
                          <img width={"25%"} src={NoDataImg}></img>
                          <br />
                          <label style={{ fontWeight: 'bold' }}>
                            {LOADING_ENABLE ? <>Loading Data.....</> : <>No Data Found</>}
                          </label>
                        </div>
                      </>
                    )}
                  </div>
                  {datalist && datalist.length > 0 ? (
                    <>
                      <div className="card-footer py-4">
                        <Box display="flex" justifyContent="right" alignItems='center'>
                          <span>Total record: {pagerecord?.totalItems}</span>
                          <Pagination
                            className="custom-pagination-class"
                            count={pagerecord?.totalPages}
                            page={page}
                            onChange={handleChange}
                            color="secondary"
                          />
                        </Box>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
            <AddLanguage
              show={showAddTag}
              languageFormData={languageFormData}
              setLanguageFormData={setLanguageFormData}
              onSubmit={() => handleOnSubmitLanguageModel()}
              onHide={() => handleHideForm()}
            />
          </div>
            </>
          ) : (<InsufficientPermission/>)
        }
        </div>
      </>
    </>
  );
};
